import { useState } from 'react'
import styles from './EditZonesNamesModalContainer.module.scss'
import { Modal } from '@material-ui/core'

const EditZonesNamesModalContainer = props => {
  const { hideModal, translate, system, handleSaveZonesNames } = props
  const { controlIngenium } = system || {}
  const zones = controlIngenium?.zones || []

  const [zonesNames, setZonesNames] = useState(
    zones.map(zone => ({
      zoneID: zone.zoneID,
      zoneName: zone.zoneName || '',
      edited: false
    }))
  )

  const [open] = useState(true)
  const [error, setError] = useState(null)

  const getDefaultZoneName = zoneID => `${translate('zone')} ${zoneID + 1}`

  const onZoneNameChange = (zoneID, newName) => {
    setZonesNames(prevNames =>
      prevNames.map(zone =>
        zone.zoneID === zoneID ? { ...zone, zoneName: newName, edited: true } : zone
      )
    )
    setError(null)
  }

  // Devuelve los nombres normalizados o null si hay error
  const validateAndNormalizeZonesNames = zonesNames => {
    const namesSet = new Set()
    const normalized = []

    for (const zone of zonesNames) {
      const trimmedName = zone.zoneName?.trim()
      const defaultName = getDefaultZoneName(zone.zoneID)

      // Si el usuario ha tocado el campo y lo ha dejado vacío -> error
      if (zone.edited && !trimmedName) {
        setError(translate('emptyZoneNames'))
        return null
      }

      // Si no está editado y está vacío, usamos el nombre por defecto
      const finalName = trimmedName || defaultName

      if (namesSet.has(finalName)) {
        setError(translate('repeatedZoneNames'))
        return null
      }

      namesSet.add(finalName)
      normalized.push({
        zoneID: zone.zoneID,
        zoneName: finalName
      })
    }

    return normalized
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={hideModal}
        aria-labelledby='edit-zones-names-modal-title'
        aria-describedby='edit-zones-names-modal-description'
      >
        <div className={styles.centerContainer}>
          <div className={styles.modalContainer}>
            <div className={styles.headerWrapper}>
              <span className={styles.header}>{translate('editZonesNames')}</span>
            </div>
            <div className={styles.zonesList}>
              {zones.map((zone, index) => (
                <div
                  key={index}
                  className={styles.zoneItem}
                  style={{ maxHeight: error ? '60vh' : '65vh' }}
                >
                  <label className={styles.zoneLabel}>
                    {translate('zone')} {zone.zoneID + 1}
                  </label>
                  <input
                    type='text'
                    className={styles.zoneInput}
                    placeholder={translate('renameZone')}
                    value={zonesNames.find(z => z.zoneID === zone.zoneID)?.zoneName || ''}
                    onChange={e => onZoneNameChange(zone.zoneID, e.target.value)}
                  />
                </div>
              ))}
            </div>
            {error && <div className={styles.error}>{error}</div>}
            <div className={styles.buttonContainer}>
              <button
                className={styles.saveButton}
                onClick={() => {
                  const normalized = validateAndNormalizeZonesNames(zonesNames)
                  if (!normalized) return

                  handleSaveZonesNames(normalized)
                  hideModal()
                }}
              >
                {translate('save')}
              </button>
              <button
                className={styles.cancelButton}
                onClick={hideModal}
              >
                {translate('cancel')}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default EditZonesNamesModalContainer
